import React, { useEffect, useRef } from "react";

const MuvChatEmbed = ({ uuid }) => {
    const iframeRef = useRef(null);

    useEffect(() => {
        const handleMessage = (event) => {
            if (!event.origin.includes("muvbot-dun.vercel.app")) return;
            const iframe = iframeRef.current;
            if (!iframe) return;

            if (event.data.type === "chat_expand") {
                iframe.style.width = "1200px";
                iframe.style.height = "1100px";
                iframe.style.borderRadius = "16px";
                iframe.style.pointerEvents = "auto";
                iframe.style.left = "50%";
                iframe.style.transform = "translateX(-50%)";
                iframe.style.right = "auto"; // disable right
            }

            if (event.data.type === "chat_dock") {
                iframe.style.width = "100px";
                iframe.style.height = "100px";
                iframe.style.borderRadius = "50%";
                iframe.style.pointerEvents = "auto";
                iframe.style.left = "auto";
                iframe.style.right = "20px";
                iframe.style.transform = "none";
            }
        };

        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, []);

    return (
        <iframe
            ref={iframeRef}
            id="chat-widget"
            src={`https://muvbot-dun.vercel.app?uuid=${uuid}`}
            title="mûvGPT Chat Widget"
            style={{
                position: "fixed",
                bottom: "20px",
                right: "20px",
                width: "100px",
                height: "100px",
                border: "none",
                borderRadius: "50%",
                zIndex: 9999,
                transition: "all 0.3s ease",
                pointerEvents: "none",
            }}
        />
    );
};

export default MuvChatEmbed;
